export enum WorkorderCreationBehavior {
  ReuseForVehicle = 'reuse_for_vehicle',
  ReuseForReference = 'reuse_for_reference',
  ForceNewOrder = 'force_new_order'
}
